// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
  padding: 0 10px 20px;
}

.main-title {
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
  padding: 10px 0 2px 0;
}

.main-container {
  background-color: white;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
}

.main-container.FF-scroll-modify {
  max-height: 850px !important;
  height: 100% !important;
  margin-top: 15px;
}

.heading {
  color: #000;
  font-size: 18px;
  font-weight: 500;
}

/*WC 051525*/
.group-detail{
  padding-block: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
}
.group-detail img{
  object-fit: contain;
  background: #ededed;
  border-radius: 10px;
  padding: 3px;
}
.groupName{
  font-size: 20px;
  font-weight:500;
  padding-block: 20px;
  margin-bottom: 0;
}
/*WC 051525*/

.below-title {
  color: #000;
  font-size: 14px;
  font-weight: 400;
}

.user_detail {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
}

.user_detail .userInfo {
  border-bottom: 1px solid #e8e8e8;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #e1e0f8;
}

.userInfo img {
  height: 40px;
  width: 40px;
  border-radius: 4px;
}

.userInfo span:last-child {
  font-size: 16px;
  /*font-weight: bold;*/
  color: #6c2fbb;
}

.userResult span {
  font-weight: 400;
  font-size: 16px;
}

.user_detail .userResult {
  padding: 5px 20px;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-around;
}

.vl {
  border-left: 1px solid #e8e8e8;
  height: 40px;
}

.detail_table thead {
  background-color: #ffffff;
  color: #ffffff;
}

.detail_table thead th {
  font-size: 16px;
  font-weight: 500;
  text-align: left;
  color: #000
}

.detail_table tbody td {
  font-size: 14px;
  font-weight: 400;
  word-break: break-all;
}

.detail_table tbody td span {
  color: #000;
}

.table>tbody>tr>td {vertical-align: middle}

.questions {
  margin: 25px 0;
}

.passingScore span {
  color: #000;
}

.profileAvtarImage {
  width: 50px;
  height: 50px;
  text-align: center;
  color: #ffffff;
  background: #bd50d0;
  border-radius: 4px;
  line-height: 2.4;
  vertical-align: middle;
  text-transform: uppercase;
  text-decoration: none;
  font-size: 20px;
  font-weight: bold;
}

@media (min-width: 320px) and (max-width: 768px) {
  .main_row {
    padding: 10px 20px !important;
  }
  .breadcrumb {
    padding: 15px 17px !important;
  }

  .detail_table {
    overflow: auto;
  }
}

@media (max-width: 991px) {
  .heading {
    font-size: 24px;
  }
}

@media (max-width: 425px) {
  .userResult {
    align-items: baseline !important;
    flex-direction: column;
  }

  .vl {
    display: none;
  }
  .userInfo img {
    height: 45px;
    width: 45px;
  }
  .userInfo span:last-child {
    font-size: 17px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/questionnaire-details/questionnaire-details.component.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA,YAAY;;AAEZ;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA,oBAAoB,sBAAsB;;AAE1C;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".main {\n  padding: 0 10px 20px;\n}\n\n.main-title {\n  position: sticky;\n  top: 0;\n  background: white;\n  z-index: 1;\n  padding: 10px 0 2px 0;\n}\n\n.main-container {\n  background-color: white;\n  border: 1px solid #e8e8e8;\n  border-radius: 12px;\n}\n\n.main-container.FF-scroll-modify {\n  max-height: 850px !important;\n  height: 100% !important;\n  margin-top: 15px;\n}\n\n.heading {\n  color: #000;\n  font-size: 18px;\n  font-weight: 500;\n}\n\n/*WC 051525*/\n.group-detail{\n  padding-block: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 15px;\n}\n.group-detail img{\n  object-fit: contain;\n  background: #ededed;\n  border-radius: 10px;\n  padding: 3px;\n}\n.groupName{\n  font-size: 20px;\n  font-weight:500;\n  padding-block: 20px;\n  margin-bottom: 0;\n}\n/*WC 051525*/\n\n.below-title {\n  color: #000;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.user_detail {\n  border: 1px solid #e8e8e8;\n  border-radius: 8px;\n}\n\n.user_detail .userInfo {\n  border-bottom: 1px solid #e8e8e8;\n  padding: 10px 20px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background-color: #e1e0f8;\n}\n\n.userInfo img {\n  height: 40px;\n  width: 40px;\n  border-radius: 4px;\n}\n\n.userInfo span:last-child {\n  font-size: 16px;\n  /*font-weight: bold;*/\n  color: #6c2fbb;\n}\n\n.userResult span {\n  font-weight: 400;\n  font-size: 16px;\n}\n\n.user_detail .userResult {\n  padding: 5px 20px;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  justify-content: space-around;\n}\n\n.vl {\n  border-left: 1px solid #e8e8e8;\n  height: 40px;\n}\n\n.detail_table thead {\n  background-color: #ffffff;\n  color: #ffffff;\n}\n\n.detail_table thead th {\n  font-size: 16px;\n  font-weight: 500;\n  text-align: left;\n  color: #000\n}\n\n.detail_table tbody td {\n  font-size: 14px;\n  font-weight: 400;\n  word-break: break-all;\n}\n\n.detail_table tbody td span {\n  color: #000;\n}\n\n.table>tbody>tr>td {vertical-align: middle}\n\n.questions {\n  margin: 25px 0;\n}\n\n.passingScore span {\n  color: #000;\n}\n\n.profileAvtarImage {\n  width: 50px;\n  height: 50px;\n  text-align: center;\n  color: #ffffff;\n  background: #bd50d0;\n  border-radius: 4px;\n  line-height: 2.4;\n  vertical-align: middle;\n  text-transform: uppercase;\n  text-decoration: none;\n  font-size: 20px;\n  font-weight: bold;\n}\n\n@media (min-width: 320px) and (max-width: 768px) {\n  .main_row {\n    padding: 10px 20px !important;\n  }\n  .breadcrumb {\n    padding: 15px 17px !important;\n  }\n\n  .detail_table {\n    overflow: auto;\n  }\n}\n\n@media (max-width: 991px) {\n  .heading {\n    font-size: 24px;\n  }\n}\n\n@media (max-width: 425px) {\n  .userResult {\n    align-items: baseline !important;\n    flex-direction: column;\n  }\n\n  .vl {\n    display: none;\n  }\n  .userInfo img {\n    height: 45px;\n    width: 45px;\n  }\n  .userInfo span:last-child {\n    font-size: 17px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
